(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const materials = ['Travertino Romano Silver','Travertino Romano','Travertino Nacional','Verde Guatemala','Verde Esmeralda','Verde Alpi','Taj Mahal','Cristallo Gold','Cristallo Rosé','Calacatta Gold Premium','Calacatta Premium','Calacatta','Marrom Imperador','Marrom Emperador','Nero Striato','Grigio Vulcano','Branco Cintilante','Terracota Imperial','Azul Mediterrâneo','Sodalita','Ônix','São Gabriel'];
  const publish = (event, data) => {
    if (window.Shopify?.designMode) return;
    try {
      const consent = window.Shopify?.customerPrivacy;
      if (!consent || !consent.analyticsProcessingAllowed()) return;
      const result = window.Shopify?.analytics?.publish?.('artegran:' + event, data);
      if (result?.catch) result.catch(() => {});
    } catch (_) {}
  };
  function init(root = document) {
    root.querySelectorAll('[data-ag-tray-grid]').forEach(grid => {
      if (grid.dataset.ready) return;
      grid.dataset.ready = 'true';
      const form = grid.querySelector('[data-ag-filters]');
      const list = grid.querySelector('[data-ag-products]');
      const cards = [...grid.querySelectorAll('[data-ag-product]')];
      const stones = new Set(), sizes = new Set();
      cards.forEach(card => {
        const title = normalize(card.dataset.title);
        card._stone = materials.find(m => title.includes(normalize(m))) || '';
        const match = title.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/) || title.match(/(?:ø\s*)?(\d+(?:[.,]\d+)?)\s*cm/);
        card._size = match ? (match[2] ? match[1] + ' × ' + match[2] : match[1]) + ' cm' : '';
        if (card._stone) stones.add(card._stone);
        if (card._size) sizes.add(card._size);
      });
      [[form.elements.stone, stones], [form.elements.size, sizes]].forEach(([select, values]) => {
        [...values].sort((a,b) => a.localeCompare(b,'pt-BR',{numeric:true})).forEach(value => select.add(new Option(value,value)));
      });
      function filter() {
        const max = form.elements.max.value === '' ? Infinity : Number(form.elements.max.value) * 100;
        let count = 0;
        cards.forEach(card => {
          card.hidden = !!((form.elements.stone.value && card._stone !== form.elements.stone.value) || (form.elements.size.value && card._size !== form.elements.size.value) || Number(card.dataset.price) > max || (form.elements.available.checked && card.dataset.available !== 'true'));
          if (!card.hidden) count++;
        });
        const order = form.elements.sort.value;
        [...cards].sort((a,b) => order === 'curated' ? Number(a.dataset.order)-Number(b.dataset.order) : (Number(a.dataset.price)-Number(b.dataset.price))*(order === 'high' ? -1 : 1)).forEach(card => list.append(card));
        grid.querySelector('[data-ag-count] span').textContent = count;
        grid.querySelector('[data-ag-empty]').hidden = count > 0;
      }
      form.addEventListener('input', filter);
      form.addEventListener('change', filter);
      form.addEventListener('submit', event => event.preventDefault());
      form.addEventListener('reset', () => requestAnimationFrame(filter));
      form.hidden = false;
      grid.querySelectorAll('.ag-use-links a').forEach(a => {if (a.pathname === location.pathname) a.setAttribute('aria-current','page');});
      filter();
    });
    if (root.querySelector('[data-ag-corporate-success]')) publish('corporate_success', {form:'corporate'});
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) root.querySelectorAll('.ag-commerce-hero .slideshow__autoplay:not(.slideshow__autoplay--paused)').forEach(button => button.click());
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ag-event]');
    if (link) publish(link.dataset.agEvent, {item:link.dataset.agItem || '',page:location.pathname});
  });
  document.addEventListener('submit', event => {if (event.target.id === 'CorporateContactForm') publish('corporate_submit',{form:'corporate'});});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
